<style lang="scss" src='./Schedule.scss' scoped></style>
<template src="./Schedule.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
  } from "vuex";
  import moment from 'moment';

  export default {
    name: "Schedule",
    components: {},
    data() {
      return {
        selected: null,
        tabSchIndex: 0,
        showError: false,
        loading: false,
      };
    },
    computed: {
      ...mapGetters('CartStore', ['getDeliveryMethods']),
      ...mapState('CartStore', ['cartProducts']),
    },

    methods: {
      ...mapActions('CartStore', ['fnApiGetDeliveryMethods', 'fnApiDeliveryTime']),
      fnGetDate(date) {
        return this.F_capitalizeAllFirst(this.F_formatDeliveryDate(date));
      },
      fnGetDateTime(dateTime) {
        return moment(dateTime, 'hh:mm:ss').format('hh:mm A');
      },
      async fnValidate() {
        if (this.selected != null) {
          this.showError = false;
          let tempBody ={};
          for( let option of this.getDeliveryMethods.options ){
            let tempDate = option.time.find( date => date.delivery_time_id == this.selected );
            if (tempDate) {
              tempBody = {
                date: option.date,
                delivery_time_id: tempDate.delivery_time_id
              };
              break;
            }
          } 
          this.loading = true;
          await this.fnApiDeliveryTime(tempBody);
          this.loading = false;
        } else {
          this.showError = true;
        }
      }
    },
    beforeCreate() {},
    created() {},
    async mounted() {
      if( this.cartProducts.products.length == 0 ){
        this.$router.push('/');
      }
      await this.fnApiGetDeliveryMethods();
      if (this.cartProducts.delivery_method?.type == "DELIVERY") {
         this.tabSchIndex = this.getDeliveryMethods.options.findIndex( item =>  item.date == this.cartProducts.delivery_method.delivery_time.date );
         this.selected = this.cartProducts.delivery_method.delivery_time.delivery_time_id;
      }
    },
    beforeDestroy() {
    },
  };
</script>
